export default "__VITE_ASSET__38c8bab9__"